import ReferralMyStat from './ReferralMyStat';
import ColumnsContent from '../../../../../components/Hocs/ColumnsContent';

export default ColumnsContent(ReferralMyStat);



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutApp/Content/ReferralProgram/ReferralMyStat/index.js